import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSystemsManager = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11.5V9A1.5 1.5 0 0 1 16 7.5h3V5a1 1 0 0 0-1-1H3Zm10 13H9v2H7.5a.5.5 0 0 0 0 1H14a.5.5 0 0 0 0-1h-1v-2Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M17 9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-4Zm2 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcSystemsManager");

export { IcSystemsManager };
//# sourceMappingURL=ic-systems-manager.js.map
